import moment from "moment";
import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Button } from "../../Component/Button/Button";
import NoData from "../../Component/NoData/NoData";
import SideBarSkeleton from "../../Component/SideBarSkeleton";
import TableSkeleton from "../../Component/TableSkeleton";
import { BaseURL, endpointsUrl, recordsLimit } from "../../config/apiUrl";
import classes from "./UploadedVideo.module.css";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/Add";
import AddTeamMember from "../../modals/AddTeamMember";
import DeleteIcon from "@mui/icons-material/Delete";
import EditTeamMember from "../../modals/EditTeamMember";
import { useSelector } from "react-redux";
import { Get } from "../../Axios/AxiosFunctions";
import PaginationComponent from "../../Component/PaginationComponent";
import ViewVideoModal from "../../modals/ViewVideoModal";
const UploadedVideo = () => {
  let loading = false;
  const { access_token, user } = useSelector((state) => state?.authReducer);
  const [isLoading, stIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [showModal, setShowModal] = useState(null);




  const [show, setShow] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [pageNo, setPageNo] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);

  const getUploadVideos = async (pg = pageNo) => {
    const url = BaseURL(
      `video/${endpointsUrl(
        user?.role
      )}/all?page=${pg}&limit=${recordsLimit}&status=posted`
    );
    stIsLoading(true);
    const response = await Get(url, access_token);
    if (response) {
      setData(response?.data?.data);
      setTotalRecords(response?.data?.totalRecords);
    }
    stIsLoading(false);
  };

  useEffect(() => {
    getUploadVideos();
  }, [pageNo]);
  const [files, setFiles] = useState([
    {
      name: "Jhon Doe",
      lastName: "Jhon Doe",
      email: "info.Abc@gmail.com",
      status: "Active",
    },
    {
      name: "Jhon Doe",
      lastName: "Jhon Doe",
      email: "info.Abc@gmail.com",
      status: "Active",
    },
    {
      name: "Jhon Doe",
      lastName: "Jhon Doe",
      email: "info.Abc@gmail.com",
      status: "Active",
    },
    {
      name: "Jhon Doe",
      lastName: "Jhon Doe",
      email: "info.Abc@gmail.com",
      status: "Active",
    },
    {
      name: "Jhon Doe",
      lastName: "Jhon Doe",
      email: "info.Abc@gmail.com",
      status: "Active",
    },
  ]);
  return (
    <>
      <style>{`
      .table100-body{
        height:calc(100vh - 310px);
        overflow-y:scroll;
      }
  @media screen and (max-width:1440px){
      .table100-head, .table100-body{
        width:1200px;
      }
      .table100.ver1{
        overflow-x:scroll !important;
      }
    }

      `}</style>
      <SideBarSkeleton>
        <Container className="custom_conti_b">
          <Row className="mb-3">
            <Col md={6}>
              <h3>Uploaded Videos</h3>
            </Col>
            <Col md={6}>
              {/* <div className="d-flex">
                <div className={classes.searchInput}>
                  <input placeholder="Name" />
                  <SearchIcon />
                </div>
                <div className={classes.button_div}>
                  <Button
                    onClick={() => setShowModal("TeamMember")}
                    label={"Team Member"}
                    leftIcon={<AddIcon />}
                  />
                </div>
              </div> */}
            </Col>
          </Row>
          <Row className={classes.main}>
            <Col md={12}>
              <div class="table100 ver1 m-b-110">
                <div class="table100-head">
                  <table>
                    <thead>
                      <tr class="row100 head">
                        <th
                          class="cell100 column1"
                          style={{ width: "14.28%", textAlign: "center" }}
                        >
                          S.No
                        </th>
                        <th
                          class="cell100 column2"
                          style={{ width: "14.28%", textAlign: "center" }}
                        >
                          Team Member
                        </th>
                        <th
                          class="cell100 column3"
                          style={{ width: "14.28%", textAlign: "center" }}
                        >
                          Email
                        </th>
                        <th
                          class="cell100 column4"
                          style={{ width: "14.28%", textAlign: "center" }}
                        >
                          Channel
                        </th>

                        <th class="cell100 column5" style={{ width: "14.28%" }}>
                          Date
                        </th>
                        <th class="cell100 column5" style={{ width: "14.28%" }}>
                          Day
                        </th>
                        <th class="cell100 column5" style={{ width: "14.28%" }}>
                          Video
                        </th>
                      </tr>
                    </thead>
                  </table>
                </div>
                {isLoading ? (
                  <TableSkeleton rowsCount={recordsLimit} colsCount={7} />
                ) : (
                  <div class="table100-body js-pscroll ps ps--active-y">
                    <table>
                      <tbody>
                        {data?.length > 0 ? (
                          data?.map((item, index) => (
                            <tr class="row100 body">
                              <td
                                class="cell100 column1"
                                style={{ width: "14.28%", textAlign: "center" }}
                              >
                                {index + 1}
                              </td>
                              <td
                                class="cell100 column2"
                                style={{
                                  width: "14.28%",
                                  textAlign: "center",
                                }}
                              >
                                <div className={classes.descCol}>
                                  {item?.uploadedBy?.userName}
                                </div>
                              </td>

                              <td
                                class="cell100 column4"
                                style={{ width: "14.28%", textAlign: "center" }}
                              >
                                <div className={classes.descCol}>
                                  {item?.uploadedBy?.email}
                                </div>
                              </td>

                              <td
                                class="cell100 column4"
                                style={{ width: "14.28%", textAlign: "center" }}
                              >
                                {item?.channel?.instagramId}
                              </td>
                              <td
                                class="cell100 column5"
                                style={{ width: "14.28%" }}
                              >
                                {moment(item?.scheduledDate).format(
                                  "DD MMM YYYY"
                                )}
                              </td>
                              <td
                                class="cell100 column5"
                                style={{ width: "14.28%" }}
                              >
                                {moment(item?.scheduledDate).format("ddd")}
                              </td>
                              <td
                                class="cell100 column5"
                                style={{ width: "14.28%" }}
                              >
                                <span
                                  className={classes.view}
                                  onClick={() => {
                                    setSelectedItem(item);
                                    setShow("Video");
                                  }}
                                >
                                  View
                                </span>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <NoData text={"No Videos Found"} />
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </Col>
          </Row>
          <div className={classes.paginationDiv}>
            <PaginationComponent
              currentPage={pageNo}
              setCurrentPage={setPageNo}
              totalPages={Math.ceil(totalRecords / recordsLimit)}
            />
          </div>
        </Container>
        {show == "Video" && (
          <ViewVideoModal
            show={show == "Video"}
            setShow={setShow}
            data={selectedItem}
          />
        )}
      </SideBarSkeleton>
      {/* {showModal == "TeamMember" && (
        <AddTeamMember
          show={showModal == "TeamMember"}
          setShow={setShowModal}
        />
      )}
      {showModal == "editTeamMember" && (
        <EditTeamMember
          show={showModal == "editTeamMember"}
          setShow={setShowModal}
        />
      )} */}
    </>
  );
};

export default UploadedVideo;
